import { Auth } from '@supabase/auth-ui-react'
import { ThemeSupa } from '@supabase/auth-ui-shared'
import { supabase } from '../lib/supabase'
import { useAuth } from '../contexts/AuthContext'
import { Navigate } from 'react-router-dom'
import { useThemeContext } from '../contexts/ThemeContext'

export function Login() {
  const { user, loading } = useAuth()
  const { resolvedTheme } = useThemeContext()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    )
  }

  // Redirect if already logged in
  if (user) {
    return <Navigate to="/calculator" replace />
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 px-4">
      <div className="max-w-md w-full p-8 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-center mb-2 text-gray-900 dark:text-white">
          Sign In
        </h1>
        <p className="text-center text-gray-600 dark:text-gray-400 mb-6">
          Sign in with your social account to access the calculator
        </p>
        <Auth
          supabaseClient={supabase}
          appearance={{
            theme: ThemeSupa,
            variables: {
              default: {
                colors: {
                  brand: '#3b82f6',
                  brandAccent: '#2563eb',
                },
              },
            },
          }}
          theme={resolvedTheme === 'dark' ? 'dark' : 'light'}
          providers={['google']}
          redirectTo={`${window.location.origin}/auth/callback`}
          onlyThirdPartyProviders={true}
        />
      </div>
    </div>
  )
}
